import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { Box, Card, Grid, Typography, useTheme } from "@mui/material";
import React from "react";

import MultiSelectFilterCard from "components/pages/dashboard/surgery_types_procedures/filter/cards/MultiSelectFilterCard";
import RangeFilterCard from "components/pages/dashboard/surgery_types_procedures/filter/cards/RangeFilterCard";
import SingleSelectFilterCard from "components/pages/dashboard/surgery_types_procedures/filter/cards/SingleSelectFilterCard";
import FilterButtons from "components/pages/dashboard/surgery_types_procedures/filter/FilterButtons";
import CriteriaSummary from "components/pages/dashboard/surgery_types_procedures/filter/summary/CriteriaSummary";
import useActiveProcedure from "components/pages/dashboard/surgery_types_procedures/hooks/useActiveProcedure";

const FILTER_CARD_BY_TYPE = {
  range: RangeFilterCard,
  multiSelect: MultiSelectFilterCard,
  singleSelect: SingleSelectFilterCard,
};

const groupFiltersByCardTitle = (filters) => {
  const groupsByKey = new Map();

  filters.forEach((filter) => {
    const key = filter.cardTitle ?? filter.field;
    const group = groupsByKey.get(key);

    if (group) {
      group.filters.push(filter);
      return;
    }

    groupsByKey.set(key, { key, type: filter.type, filters: [filter] });
  });

  return [...groupsByKey.values()];
};

const ProcedureFilter = () => {
  const theme = useTheme();
  const { activeProcedure } = useActiveProcedure();
  const border = `1px solid ${theme.palette.border.main}`;

  return (
    <Card elevation={0} sx={{ border, borderRadius: "8px" }}>
      <Box
        sx={{
          px: 3,
          py: 2.5,
          bgcolor: theme.palette.background.default,
          borderBottom: border,
        }}
      >
        <Typography variant="h5" sx={{ fontSize: "1.125rem", fontWeight: 600 }}>
          {`Generate ${activeProcedure.name} Report`}
        </Typography>
        <Typography
          variant="body1"
          sx={{ mt: 0.5, color: theme.palette.text.secondary }}
        >
          Configure filtering thresholds to isolate target patient registry
          cohorts.
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 3,
          py: 1.5,
          bgcolor: theme.palette.grey[50],
          borderBottom: border,
        }}
      >
        <InfoOutlined
          fontSize="small"
          sx={{ color: theme.palette.secondary.main }}
        />
        <Typography
          variant="body2"
          sx={{ color: theme.palette.text.secondary }}
        >
          All filters are optional. Running without filters executes an
          unrestricted search across the full registry.
        </Typography>
      </Box>
      <Box sx={{ p: 3 }}>
        <Grid container spacing={2}>
          {groupFiltersByCardTitle(activeProcedure.filters).map((group) => {
            const FilterCardComponent = FILTER_CARD_BY_TYPE[group.type];

            if (!FilterCardComponent) {
              return null;
            }

            return (
              <Grid item xs={12} md={4} key={group.key}>
                <FilterCardComponent
                  filter={group.filters[0]}
                  filters={group.filters}
                />
              </Grid>
            );
          })}
        </Grid>
        <CriteriaSummary />
        <FilterButtons />
      </Box>
    </Card>
  );
};

export default ProcedureFilter;
